import * as React from "react"

const ZoomOutSVG = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={23} height={22} fill="none" {...props}>
		<path fill="#475163" d="M7.559 8.662a.687.687 0 0 0 0 1.375h4.583a.688.688 0 0 0 0-1.375H7.559Z" />
		<path
			fill="#475163"
			fillRule="evenodd"
			d="M5.449 13.7a6.188 6.188 0 0 0 8.237.458l4.726 4.726a.688.688 0 1 0 .972-.971l-4.725-4.727a6.188 6.188 0 1 0-9.21.514Zm.972-7.78a4.813 4.813 0 0 0 6.801 6.812l.005-.005.003-.005a4.812 4.812 0 0 0-6.809-6.8V5.92Z"
			clipRule="evenodd"
		/>
	</svg>
)

export default ZoomOutSVG
